/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1Exam202,
  PostApiV1Exam400,
  PostApiV1Exam401,
  PostApiV1Exam500,
  PostApiV1ExamMutationRequest,
  PostApiV1ExamMutationResponse,
} from "../../types/examEvaluationController/PostApiV1Exam.ts";
import { examEditorViewModelSchema } from "../examEditorViewModelSchema.ts";

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1Exam202Schema = z
  .number()
  .int() as unknown as ToZod<PostApiV1Exam202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1Exam400Schema =
  z.any() as unknown as ToZod<PostApiV1Exam400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1Exam401Schema =
  z.any() as unknown as ToZod<PostApiV1Exam401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1Exam500Schema =
  z.any() as unknown as ToZod<PostApiV1Exam500>;

export const postApiV1ExamMutationRequestSchema = z.lazy(
  () => examEditorViewModelSchema,
) as unknown as ToZod<PostApiV1ExamMutationRequest>;

export const postApiV1ExamMutationResponseSchema = z.lazy(
  () => postApiV1Exam202Schema,
) as unknown as ToZod<PostApiV1ExamMutationResponse>;
